/** 대시보드 등에서 행동특성 저장 후 연간진도표가 데이터를 다시 불러오게 할 때 사용 */

export const ANNUAL_BEHAVIOR_NOTES_SAVED_EVENT = 'cp:annual-behavior-notes-saved';

export type AnnualBehaviorNotesSavedDetail = {
  workspaceId: string;
  academicYear: number;
  termNumber: 1 | 2;
  gradeId: string;
};

export function emitAnnualBehaviorNotesSaved(detail: AnnualBehaviorNotesSavedDetail): void {
  if (typeof window === 'undefined') return;
  if (!detail.gradeId) return;
  window.dispatchEvent(new CustomEvent(ANNUAL_BEHAVIOR_NOTES_SAVED_EVENT, { detail }));
}
